import { createSelector } from '@reduxjs/toolkit';
import { Decimal } from 'decimal.js';

const getLuxeLevels = (state) => state.pointsBurnLuxeTiers.levels;
export const getLuxePointsLevels = createSelector(getLuxeLevels, (levels) =>
  levels.map((level) => ({ min: new Decimal(level.min), max: new Decimal(level.max || Infinity), rate: new Decimal(level.rate) })),
);
export const getLuxeInstanceName = (state) => state.pointsBurnLuxeTiers.name;
export const getLuxeInstanceId = (state) => state.pointsBurnLuxeTiers.id;
